<template>
  <div class="custom-fields-container">
    <div>
      <RexModalLabel :primaryLabel="$t('anomalyCount') + $t('asterisk')" />
      <BaseIcon
        class="align-icon"
        name="starFilled"
        width="1rem"
        height="1rem"
      />
    </div>
    <div>
      <RexFormInputDropdown
        type="number"
        style="width: 20.75em; height: 2.5em"
        :value="anomalyCountVal"
        :boldActive="true"
        @update="handleAnomalyCountChange"
        id="input-anomaly-count-value"
        :maxLength="anomalyCountMax"
        @keydown="
          (event) => $emit('keydownEventForAnomalyCount', event, 'anomalyCount')
        "
      />
      <RexInfoLabel
        :class="'custom-styles-for-sublabel'"
        :isError="true"
        :info="anomalyCountErrorInfo"
        v-if="showValidationMessage"
      />
    </div>
  </div>
  <div class="custom-fields-container select-field">
    <div>
      <RexModalLabel :primaryLabel="$t('severity') + $t('asterisk')" />
      <BaseIcon
        class="align-icon"
        name="starFilled"
        width="1rem"
        height="1rem"
      />
    </div>
    <RexSearchSelect
      style="height: 2.5em; width: 20.75em"
      :data="severityOptions"
      :current="currentSeverity"
      :isSearch="false"
      @onChoose="severityOptionsHandler"
      id="select-severity"
    />
  </div>
</template>

<script>
import RexModalLabel from '@/rex-components/rex-modal-label.vue';
import RexInfoLabel from '@/rex-components/rex-info-label.vue';
import RexSearchSelect from '@/rex-components/RexSearchSelect.vue';
import RexFormInputDropdown from '@/rex-components/rex-modal-input-dropdown.vue';
import { SEVERITY_OPTIONS } from '@/components/AlertsV2/constants';

export default {
  emits: [
    'keydownEventForAnomalyCount',
    'updateAnomalyCountVal',
    'updateSeverity',
  ],
  components: {
    RexSearchSelect,
    RexModalLabel,
    RexFormInputDropdown,
    RexInfoLabel,
  },
  props: {
    anomalyCountVal: {
      type: Number,
      default: 1,
    },
    currentSeverity: {
      type: Object,
      default: SEVERITY_OPTIONS[0],
    },
  },
  computed: {
    showValidationMessage() {
      return !!this.anomalyCountErrorInfo;
    },
  },
  data() {
    return {
      severityOptions: SEVERITY_OPTIONS,
      anomalyCountMax: 3,
      anomalyCountErrorInfo: '',
    };
  },
  methods: {
    severityOptionsHandler(option) {
      this.$emit('updateSeverity', option);
    },
    handleAnomalyCountChange(input) {
      if (
        !input ||
        isNaN(Number(input)) ||
        Number(input) < 1 ||
        Number(input) > 300
      ) {
        this.anomalyCountErrorInfo = this.$t('anomalyCountValidationMessage');
        this.$emit('updateAnomalyCountVal', this.anomalyCountVal, true);
      } else {
        this.anomalyCountErrorInfo = '';
        this.$emit('updateAnomalyCountVal', Number(input), false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.custom-fields-container {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
  max-width: 100%;
}

.custom-styles-for-sublabel {
  max-width: fit-content !important;
  word-wrap: break-word;
}

.align-icon {
  margin-right: 1em;
  @include svg-fill($color-active-blue);
  vertical-align: super;
}
</style>
